import React from 'react';
import PropTypes from 'prop-types';

export default function VatToggle({ onToggle }) {
  return (
    <p style={{ fontStyle: 'italic', fontSize: 'small' }}>
      * Prices include VAT for EU countries. Click
      {' '}
      <button
        type="button"
        className="link--inverse"
        onClick={onToggle}
      >
        here
      </button>
      {' '}
      to display details.
    </p>
  );
}

VatToggle.displayName = 'VatToggle';

VatToggle.propTypes = {
  onToggle: PropTypes.func.isRequired,
};